import { useMemo } from 'react';

import { LedgerDatasetFilterParams, LedgerViewMode } from '../../../api/types';

interface UseInventoryQueriesParams {
    ledgerViewMode: LedgerViewMode;
    datasetFilters: Omit<LedgerDatasetFilterParams, 'source'>;
}

const useInventoryQueries = ({
    ledgerViewMode,
    datasetFilters,
}: UseInventoryQueriesParams) => {
    const inventoryQueryReady = useMemo(() => (
        ledgerViewMode !== 'inventory'
        || (
            datasetFilters.sort_by === 'most_recent_seen_at'
            && datasetFilters.sort_order === 'desc'
            && datasetFilters.status === undefined
            && datasetFilters.transaction_type === undefined
            && datasetFilters.account_name === undefined
            && datasetFilters.split_account_name === undefined
            && datasetFilters.balance_state === undefined
        )
    ), [datasetFilters.account_name, datasetFilters.balance_state, datasetFilters.sort_by, datasetFilters.sort_order, datasetFilters.split_account_name, datasetFilters.status, datasetFilters.transaction_type, ledgerViewMode]);

    return {
        inventoryQueryReady,
    };
};

export default useInventoryQueries;
